import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useLang } from "@/contexts/LanguageContext";
import { useSettings } from "@/contexts/SettingsContext";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { CATEGORY_KEYS } from "@/i18n";

export default function CollectionsPage() {
  const { t } = useLang();
  const { img } = useSettings();
  const items = [...CATEGORY_KEYS.map((c) => ({ slug: c, label: t(`cat_${c}`), desc: t(`cat_${c}_desc`), image: img(`cat_${c}`) })),
    { slug: "accessoires", label: t("nav_accessories"), desc: "", image: img("cat_abendkleider") }];

  return (
    <div className="relative min-h-screen">
      <div className="vl-noise" />
      <Header />
      <section className="max-w-7xl mx-auto px-6 sm:px-8 pt-32 pb-20" data-testid="collections-page">
        <div className="text-center mb-14">
          <div className="text-xs tracking-[0.35em] uppercase text-[var(--vl-gold)] mb-3">{t("collections_sub")}</div>
          <h1 className="font-serif-display text-4xl sm:text-5xl font-light text-[var(--vl-ivory)]">{t("collections_title")}</h1>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {items.map((it) => (
            <Link to={`/collectie/${it.slug}`} key={it.slug} className="vl-card rounded-2xl overflow-hidden group block" data-testid={`collection-${it.slug}`}>
              <div className="relative h-72 overflow-hidden">
                <img src={it.image} alt={it.label} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/20 to-transparent" />
                <div className="absolute bottom-0 left-0 right-0 p-6">
                  <h3 className="font-serif-display text-2xl img-caption flex items-center gap-2">{it.label} <ArrowRight size={18} className="opacity-0 group-hover:opacity-100 transition-opacity" /></h3>
                  {it.desc && <p className="text-sm img-caption-sub mt-1">{it.desc}</p>}
                </div>
              </div>
            </Link>
          ))}
        </div>
      </section>
      <Footer />
    </div>
  );
}
